import React, { useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import {
  ExcitedEmoji,
  LaughingEmoji,
  WaterFallEmoji,
} from "../../../assets/icons/filters";
import { DragIcon } from "../../../assets/icons/icons";
import Dropdown from "../../common/dropdown";

const filtersData = [
  {
    uuid: "1a2b3c4d-vertical",
    name: "Vertical",
    type: "Free",
    options: [{ label: "Premium" }, { label: "Free" }],
    visibility: "Hide",
    visibilityOptions: [
      { label: "Show", value: "Show" },
      { label: "Hide", value: "Hide" },
    ],
    dragIcon: <DragIcon />,
    emoji: <LaughingEmoji />,
  },
  {
    uuid: "1a2b3c4d-horizontal",
    name: "Horizontal",
    type: "Free",
    options: [{ label: "Premium" }, { label: "Free" }],
    visibility: "Show",
    visibilityOptions: [
      { label: "Show", value: "Show" },
      { label: "Hide", value: "Hide" },
    ],
    dragIcon: <DragIcon />,
    emoji: <ExcitedEmoji />,
  },
  {
    uuid: "1a2b3c4d-waterfall",
    name: "Waterfall",
    type: "Premium",
    options: [{ label: "Premium" }, { label: "Free" }],
    visibility: "Hide",
    visibilityOptions: [
      { label: "Show", value: "Show" },
      { label: "Hide", value: "Hide" },
    ],
    dragIcon: <DragIcon />,
    emoji: <WaterFallEmoji />,
  },
  {
    uuid: "1a2b3c4d-waterfall2",
    name: "Waterfall 2",
    type: "Free",
    options: [{ label: "Premium" }, { label: "Free" }],
    visibility: "Show",
    visibilityOptions: [
      { label: "Show", value: "Show" },
      { label: "Hide", value: "Hide" },
    ],
    dragIcon: <DragIcon />,
    emoji: <LaughingEmoji />,
  },
  {
    uuid: "1a2b3c4d-deform",
    name: "Deform",
    type: "Premium",
    options: [{ label: "Premium" }, { label: "Free" }],
    visibility: "Hide",
    visibilityOptions: [
      { label: "Show", value: "Show" },
      { label: "Hide", value: "Hide" },
    ],
    dragIcon: <DragIcon />,
    emoji: <ExcitedEmoji />,
  },
  {
    uuid: "1a2b3c4d-sphere",
    name: "Sphere",
    type: "Premium",
    options: [{ label: "Premium" }, { label: "Free" }],
    visibility: "Show",
    visibilityOptions: [
      { label: "Show", value: "Show" },
      { label: "Hide", value: "Hide" },
    ],
    dragIcon: <DragIcon />,
    emoji: <WaterFallEmoji />,
  },
  {
    uuid: "1a2b3c4d-wavy",
    name: "Wavy",
    type: "Free",
    options: [{ label: "Premium" }, { label: "Free" }],
    visibility: "Hide",
    visibilityOptions: [
      { label: "Show", value: "Show" },
      { label: "Hide", value: "Hide" },
    ],
    dragIcon: <DragIcon />,
    emoji: <LaughingEmoji />,
  },
  {
    uuid: "1a2b3c4d-buzz",
    name: "Buzz",
    type: "Free",
    options: [{ label: "Premium" }, { label: "Free" }],
    visibility: "Show",
    visibilityOptions: [
      { label: "Show", value: "Show" },
      { label: "Hide", value: "Hide" },
    ],
    dragIcon: <DragIcon />,
    emoji: <ExcitedEmoji />,
  },
  {
    uuid: "1a2b3c4d-toon",
    name: "Toon",
    type: "Premium",
    options: [{ label: "Premium" }, { label: "Free" }],
    visibility: "Hide",
    visibilityOptions: [
      { label: "Show", value: "Show" },
      { label: "Hide", value: "Hide" },
    ],
    dragIcon: <DragIcon />,
    emoji: <WaterFallEmoji />,
  },
  {
    uuid: "1a2b3c4d-smooth-toon",
    name: "Smooth Toon",
    type: "Free",
    options: [{ label: "Premium" }, { label: "Free" }],
    visibility: "Show",
    visibilityOptions: [
      { label: "Show", value: "Show" },
      { label: "Hide", value: "Hide" },
    ],
    dragIcon: <DragIcon />,
    emoji: <LaughingEmoji />,
  },
  {
    uuid: "1a2b3c4d-swirl",
    name: "Swirl",
    type: "Premium",
    options: [{ label: "Premium" }, { label: "Free" }],
    visibility: "Hide",
    visibilityOptions: [
      { label: "Show", value: "Show" },
      { label: "Hide", value: "Hide" },
    ],
    dragIcon: <DragIcon />,
    emoji: <ExcitedEmoji />,
  },
  {
    uuid: "1a2b3c4d-crack",
    name: "Crack",
    type: "Premium",
    options: [{ label: "Premium" }, { label: "Free" }],
    visibility: "Show",
    visibilityOptions: [
      { label: "Show", value: "Show" },
      { label: "Hide", value: "Hide" },
    ],
    dragIcon: <DragIcon />,
    emoji: <WaterFallEmoji />,
  },
];

export default function Filters() {
  const [filters, setFilters] = useState(filtersData);
  const [openDropdownStatusIndex, setOpenDropdownStatusIndex] = useState(null);
  const [openDropdownVisibilityIndex, setOpenDropdownVisibilityIndex] =
    useState(null);
  const [selectedOptions, setSelectedOptions] = useState(
    filters.map((filter) => ({
      status: null,
      visibility: filter.visibility,
    })),
  );

  const handleToggleStatusDropdown = (index) => {
    setOpenDropdownVisibilityIndex(null);
    setOpenDropdownStatusIndex(
      openDropdownStatusIndex === index ? null : index,
    );
  };

  const handleToggleVisibilityDropdown = (index) => {
    setOpenDropdownStatusIndex(null);
    setOpenDropdownVisibilityIndex(
      openDropdownVisibilityIndex === index ? null : index,
    );
  };

  const handleSelectedOption = (value, index, type) => {
    if (index < 0 || index >= selectedOptions.length) {
      console.error("Invalid index:", index);
      return;
    }

    const newOptions = [...selectedOptions];
    if (type === "status") {
      newOptions[index].status = value.label;
    } else if (type === "visibility") {
      newOptions[index].visibility = value.label;
    }
    setSelectedOptions(newOptions);
  };

  const handleDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;
    if (source.index === destination.index) return;
    const updatedFilters = Array.from(filters);
    const [movedFilter] = updatedFilters.splice(source.index, 1);
    updatedFilters.splice(destination.index, 0, movedFilter);
    setFilters(updatedFilters);
  };

  return (
    <div className="rounded-[20px] border border-[#0075FF1A] pb-[22px]">
      <div className="my-[20px] flex flex-row items-center justify-between px-[40px]">
        <h2 className="text-left font-outfit text-[20px] font-medium leading-[25.2px] text-[#222222]">
          Filters
        </h2>
      </div>
      {filters.length === 0 ? (
        <p>No Filters found.</p>
      ) : (
        <div className="scrollbar-hide h-[calc(100vh-285px)] overflow-hidden overflow-y-auto">
          <div className="grid grid-cols-3 gap-4 bg-[#0075FF1A] px-[40px] py-[15px]">
            <div className="text-left font-outfit text-[16px] font-medium leading-[20.16px] text-[#666666]">
              Filter Name
            </div>
            <div className="text-left font-outfit text-[16px] font-medium leading-[20.16px] text-[#666666]">
              Status
            </div>
            <div className="text-left font-outfit text-[16px] font-medium leading-[20.16px] text-[#666666]">
              Show or Hide
            </div>
          </div>
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="root" type="group">
              {(provided) => (
                <div {...provided.droppableProps} ref={provided.innerRef}>
                  {filters.map((item, index) => (
                    <div key={index} className="border-b border-[#0075FF1A]">
                      <Draggable
                        draggableId={item.uuid}
                        key={item.uuid}
                        index={index}
                      >
                        {(provided) => (
                          <div
                            {...provided.draggableProps}
                            ref={provided.innerRef}
                            className="grid grid-cols-3 gap-4 px-[40px]"
                          >
                            <div className="flex flex-row items-center gap-[40px] py-[20px] text-left font-outfit text-[14px] font-normal leading-[17.64px] text-[#222222]">
                              {/* Attach dragHandleProps to the drag icon */}
                              <div {...provided.dragHandleProps}>
                                {item.dragIcon}
                              </div>
                              <div className="flex flex-row items-center gap-[20px]">
                                {item.emoji}
                                {item.name}
                              </div>
                            </div>
                            <div className="py-[20px] text-left font-outfit text-[14px] font-normal leading-[17.64px] text-[#222222]">
                              <Dropdown
                                buttonText={
                                  selectedOptions[index]?.status || item.type
                                }
                                items={item.options}
                                isOpen={openDropdownStatusIndex === index}
                                toggleDropdown={() =>
                                  handleToggleStatusDropdown(index)
                                }
                                handleSelectedOption={(value) =>
                                  handleSelectedOption(value, index, "status")
                                }
                                className="w-[160px] border border-[#FFFFFF] bg-[#F7FAFD] text-[#0075FF]"
                              />
                            </div>
                            <div className="py-[20px] text-left font-outfit text-[14px] font-normal leading-[17.64px] text-[#222222]">
                              <Dropdown
                                buttonText={
                                  selectedOptions[index]?.visibility ||
                                  item.visibility
                                }
                                items={item.visibilityOptions}
                                isOpen={openDropdownVisibilityIndex === index}
                                toggleDropdown={() =>
                                  handleToggleVisibilityDropdown(index)
                                }
                                handleSelectedOption={(value) =>
                                  handleSelectedOption(
                                    value,
                                    index,
                                    "visibility",
                                  )
                                }
                                className={`w-[160px] border border-[#FFFFFF] bg-[#F7FAFD] ${
                                  selectedOptions[index]?.visibility === "Show"
                                    ? "text-[#15AB24]"
                                    : "text-[#D43A3A]"
                                }`}
                              />
                            </div>
                          </div>
                        )}
                      </Draggable>
                    </div>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
      )}
    </div>
  );
}
